import { computed, inject, Injectable } from '@angular/core';
import { AdminDto, AdminService } from '@api-client';
import { AuthTokenService, BaseStore, LocalStorageService } from '@client-libs';
import { toObservableSignal } from 'ngxtension/to-observable-signal';
import { lastValueFrom } from 'rxjs';

type State = {
  user: AdminDto | null;
};

@Injectable({ providedIn: 'root' })
export class UserStore extends BaseStore<State> {
  private readonly adminService = inject(AdminService);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly authTokenService = inject(AuthTokenService);

  user = toObservableSignal(computed(() => this.state()?.user));

  constructor() {
    super({
      user: null,
    });
  }

  async fetchUser() {
    const user = await lastValueFrom(this.adminService.adminControllerFindMe());

    this.setUser(user);
  }

  async logout() {
    await lastValueFrom(this.adminService.adminControllerSignOut());
    this.authTokenService.clearTokens();
  }

  setUser(user: AdminDto) {
    this.updateState({ user });
  }

  clearUser() {
    this.updateState({ user: null });
  }
}
